import { render, staticRenderFns } from "./PromoThree.vue?vue&type=template&id=cc36a466"
import script from "./PromoThree.vue?vue&type=script&lang=js"
export * from "./PromoThree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports